import './ProgressBar.css';
import { ProgressStep } from '../../../common/global-types/AdvisoryContent';

type ProgressBarProps = {
  progressStep: ProgressStep
};

function ProgressBar({ progressStep }: ProgressBarProps) {
  return (
    <div id="progress-bar">
      {Array.from({ length: progressStep.maxSteps }, (_, index) => index).map((step) => (
        <div
          key={step + 1}
          className={`step ${progressStep.currentStep >= step + 1 ? 'filled' : ''}`}
        />
      ))}
    </div>
  );
}

export default ProgressBar;
